// removed by extract-text-webpack-plugin
module.exports = {"tab":"Tabs--tab--3S_XmuTc","navigation":"Tabs--navigation--1k5fqqWK","label":"Tabs--label--5osPqST3","active":"Tabs--active--HY5S0ZOi"};


//////////////////
// WEBPACK FOOTER
// ./src/App/account/components/GetInvolvedPage/Tabs.css
// module id = 1244
// module chunks = 2